import React, { ReactNode } from "react";
import clsx from "clsx";
import { MaskedLevel, WrapperType } from "../../types";

interface MaskerProps {
  className?: string;
  isMasked?: boolean;
  maskedLevel?: MaskedLevel;
  wrapperType?: WrapperType;
  children: ReactNode | string | number;
}

const Masker: React.FC<MaskerProps> = ({
  className = "",
  isMasked = false,
  maskedLevel = MaskedLevel.Medium,
  wrapperType: Wrapper = WrapperType.Div,
  children,
}) => {
  if (!isMasked) {
    return <>{children}</>;
  }

  return (
    <Wrapper
      className={clsx(className, {
        [`wedu-masked-container-${maskedLevel}`]: isMasked,
      })}
    >
      {children}
    </Wrapper>
  );
};

export default React.memo(Masker);
